<style>
  [tuiButton][data-appearance='flat'] {
    --tui-padding: 0.5rem;
  }
  .block-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    padding: 0.5rem 0 0 0.5rem;
    height: 44px;
  }
</style>

@let title = $title();
@let selectedRequestsCount = $selectedRequestsCount();
@let canGoBack = $canGoBack();
@let previousView = $previousView();

<div class="x-card x-card_size_m x-white p-2">
  <header class="block-title flex justify-between">
    @if (canGoBack && previousView) {
      <button
        tuiIconButton
        type="button"
        class="me-4"
        appearance="transparent"
        size="s"
        tuiHintAppearance="dark"
        (click)="$viewChanged.emit(previousView)"
      >
        <tui-icon
          [style.border-width.rem]="0.25"
          icon="@tui.arrow-left"
          class="x-text-01 text-2xl!"
        ></tui-icon>
      </button>
    }
    <h3 class="ms-2.5">{{ title }}</h3>
    <button
      appearance="icon"
      iconStart="@tui.x"
      tuiIconButton
      type="button"
      size="s"
      class="me-4"
      (click)="$viewObserver().complete()"
    ></button>
  </header>
  <div class="x-card__paragraph">
    <button
      tuiButton
      appearance="flat"
      type="button"
      class="w-full p-0"
      (click)="$viewChanged.emit(GroupActionsViewsTypes.SelectedRequests)"
    >
      <span class="x-text-01 flex justify-between w-full">
        <span class="font-medium">
          {{ 'group_actions.header.selected' | translate }}
          <span tuiBadge appearance="primary" size="l" class="ms-2">{{
            selectedRequestsCount
          }}</span>
        </span>
        <tui-icon icon="@tui.chevron-right" class="me-5"></tui-icon>
      </span>
    </button>
  </div>
</div>
